module.exports = __webpack_public_path__ + "static/foi-8cf28e029ae4e862182035841487edd4.png";